<template>
    <div id="why-banner">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section section-padding">
            <div class="container">
                <div @click.stop="goToPage('strategyPage')" class="project-add-banner clickable" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                    <div class="content">
                        <span class="subtitle primary">Congruencia corporativa.</span>
                        <h2 class="title white mb-4 font-weight-100 w-100 text-wrap-balance">
                            Destinamos el <span class="bold">2%</span> de nuestros ingresos
                            para fomentar el <span class="bold">bienestar ambiental y social</span>
                            de nuestro país.
                        </h2>
                        <!-- <div class="row align-items-center mb-3">
                            <div class="col-lg-3 col-6 mb--20">
                                <div class="brand-logo">
                                    <img :src="`${logo_base}for-the-planet.png`" alt="Brand">
                                </div>
                            </div>
                            <div class="col-lg-3 col-6 mb--20">
                                <div class="brand-logo">
                                    <img :src="`${logo_base}carbonmark-green.png`" alt="Brand">
                                </div>
                            </div>
                        </div> -->
                        <button type="submit" class="rg-know-more axil-btn btn-borderd btn-fluid btn-primary rg-style-button-inline w-25 p-4"
                                name="submit-btn">Conoce más</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "WhyBanner",
    components: {
    },
    data() {
        return {
            logo_base: "https://cdn.redgirasol.com/nuevo_portal/logos/logo-"
        }
    }
}

</script>

<style scoped>
.section {
    z-index: 0 !important;
    /* top: -5rem; */
}

@media only screen and (max-width: 991px) {
    .section {
        z-index: 0 !important;
        top: 0;
        /* margin-top: 3rem; */
    }
}

.btn-fill-white {
    border: none;
}

.project-add-banner {
    width: 100%;
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/fotografias/foto-biodiversidad.png") !important;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 2rem;
}
</style>